import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Auto.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { AUTOMATION_NODE_DESCRIPTION, NodeTypes } from '../../utils';

export const AutomationNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Automation' description={AUTOMATION_NODE_DESCRIPTION} nodeType={NodeTypes.AUTOMATION} imgPath={stepIcon} />
}